import React, { useState } from "react";
import { Box, CellItem, Checkbox, Divider, Grid, Radio, Stack, } from "../components";
import { ExpandLessOutline, ExpandMoreOutline, Folder } from "../icons";
export const SelectableTreeMenu = React.memo(({ menuItem, onClick, subItem, showDivider, showIcon, open: openMenu = false, fileTree, hideCheckBox, disabled, }) => {
    const [open, setOpen] = useState(openMenu);
    const isFolder = Boolean(fileTree && menuItem.subItems);
    const showCheckBox = hideCheckBox
        ? false
        : !fileTree || (fileTree.downloadType === "files" && !isFolder);
    return (React.createElement(Grid, { container: true, flexDirection: subItem ? "row" : "column", flexWrap: subItem ? "nowrap" : "wrap", gap: subItem ? 2 : 0 },
        subItem && (React.createElement(Grid, { item: true, sx: {
                display: "flex",
                justifyContent: "flex-end",
                paddingLeft: (theme) => theme.spacing(4),
            } },
            React.createElement(Divider, { orientation: "vertical", sx: {
                    margin: 0,
                } }))),
        React.createElement(Grid, { item: true, xs: true, minWidth: 0 },
            React.createElement(Stack, null,
                React.createElement(CellItem, { key: menuItem.id, title: menuItem.title, disableHoverEffect: true, disableActiveEffect: true, readonly: disabled, startNode: !subItem && showIcon ? (React.createElement(React.Fragment, null)) : (React.createElement(Box, { sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                        } },
                        showCheckBox && (React.createElement(Checkbox, { disabled: disabled, size: (fileTree === null || fileTree === void 0 ? void 0 : fileTree.downloadType)
                                ? "xxs"
                                : "sm", onClick: () => {
                                onClick === null || onClick === void 0 ? void 0 : onClick({
                                    key: menuItem.key,
                                    id: menuItem.id,
                                    type: "item",
                                });
                            }, checked: menuItem.selected })),
                        (fileTree === null || fileTree === void 0 ? void 0 : fileTree.downloadType) === "folders" &&
                            !menuItem.disable && (React.createElement(Radio, { size: "xxs", checked: menuItem.selected, onClick: () => {
                                fileTree === null || fileTree === void 0 ? void 0 : fileTree.onSelect({
                                    key: menuItem.key,
                                    id: menuItem.id,
                                    type: "item",
                                    subitems: menuItem.subItems,
                                });
                            } })),
                        isFolder && (React.createElement(Folder, { color: "disabled" })))), endNode: menuItem.subItems &&
                        menuItem.subItems.length > 0 ? (open ? (React.createElement(ExpandLessOutline, null)) : (React.createElement(ExpandMoreOutline, null))) : undefined, onClick: () => {
                        setOpen((prev) => !prev);
                    }, 
                    //@UiDiscrepancy - The BigGeo accordion component is built off of the CellItem component but calls for a fontweight of regular when the cell item defaults to semibold.
                    slotProps: {
                        title: {
                            fontWeight: "regular",
                        },
                    }, sx: {
                        padding: 2,
                        borderRadius: "none",
                    } }),
                open &&
                    menuItem.subItems &&
                    menuItem.subItems.map((item) => (React.createElement(SelectableTreeMenu, { key: item.id, menuItem: item, onClick: (data) => {
                            onClick === null || onClick === void 0 ? void 0 : onClick(Object.assign(Object.assign({}, data), { type: "subItem" }));
                        }, subItem: true, hideCheckBox: item.hideCheckBox, fileTree: fileTree, disabled: disabled }))))),
        showDivider && (React.createElement(Grid, { item: true, xs: true },
            React.createElement(Divider, null)))));
});
//# sourceMappingURL=SelectableTreeMenu.js.map